export default {
  en: {
    editMarket: 'Edit Market',
    market: 'Market',
    keyword: 'Keyword',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    save: 'Save Changes',
    cancel: 'Cancel',
    editMarketSuccessTitle: 'Success',
    editMarketSuccessMessage: 'Update Market Success.',
    addAgent: 'Add Agent',
    agentList: 'Agent List',
    agentName: 'Agent Name',
    confirmDeleteAgentTitle: 'Confirm',
    confirmDeleteAgentMessage: 'Please confirm to remove agent',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel'
  },
  th: {
    editMarket: 'แก้ไข ตลาด',
    market: 'ตลาด',
    keyword: 'คีย์เวิร์ด',
    name: 'ชื่อ',
    description: 'รายละเอียด',
    status: 'สถานะ',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    editMarketSuccessTitle: 'สำเร็จ',
    editMarketSuccessMessage: 'แก้ไขตลาดสำเร็จ',
    addAgent: 'เพิ่มตัวแทน',
    agentList: 'รายชื่อตัวแทน',
    agentName: 'ชื่อตัวแทน',
    confirmDeleteAgentTitle: 'ยืนยัน',
    confirmDeleteAgentMessage: 'กรุณายืนยันการลบตัวแทน',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก'
  }
}
